/* eslint-disable max-len */
import React, { DetailedHTMLProps, HTMLAttributes } from 'react'

const PlusSvg = (props: DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>): JSX.Element => {
  return (
    <div {...props}>
      <svg width="14" height="14" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.5 2.34375C7.75888 2.34375 7.96875 2.55362 7.96875 2.8125V7.03125H12.1875C12.4464 7.03125 12.6562 7.24112 12.6562 7.5C12.6562 7.75888 12.4464 7.96875 12.1875 7.96875H7.96875V12.1875C7.96875 12.4464 7.75888 12.6563 7.5 12.6563C7.24112 12.6563 7.03125 12.4464 7.03125 12.1875V7.96875H2.8125C2.55362 7.96875 2.34375 7.75888 2.34375 7.5C2.34375 7.24112 2.55362 7.03125 2.8125 7.03125H7.03125V2.8125C7.03125 2.55362 7.24112 2.34375 7.5 2.34375Z"
          fill="currentColor"
        />
      </svg>
    </div>
  )
}

export default PlusSvg
